import { render, staticRenderFns } from "./AlarmMessage.vue?vue&type=template&id=0bc673fc&"
import script from "./AlarmMessage.vue?vue&type=script&lang=js&"
export * from "./AlarmMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports